<template>
  <div id="stand-detail">
    <div class="container" v-if="data != undefined">
      <img v-if="data.cover != null" :src="$imageus + data.cover + '?width=1120&height=500)'" class="header" />
      <img v-if="data.cover == null" src="/static/1120x500.png" class="header" />

      <div class="stand-header">
        <div class="logo">
          <img v-if="data.image != null" :src="$imageus + data.image + '?width=200&height=200'" alt />
          <img v-if="data.image == null" src="/static/500x500.png" alt />
        </div>

        <div class="stand-title">
          <h1>{{ data.title }}</h1>

          <span v-if="data.saloon != null">
            <i :style="svgfilter($store.state.event.color) + 'background-image: url(/static/menuicons/map-pin.svg); fill:' + $store.state.event.color + '; margin-right: 8px;'"></i>
            {{ data.saloon.title }}
          </span>
        </div>
        <!-- <a class="checkin-button" :style="data.isCheckIn == true ? 'background-color: #8C929C;' : 'background-color:' + $store.state.event.color" href="javascript:;">
          <span v-if="this.autocheckin == false"><i class="fa fa-map-marker"></i> {{ data.isCheckIn == true ? $t("checked_in") : $t("check_in") }}</span>
          <span v-if="this.autocheckin == true"><i class="fa fa-spinner spin"></i> {{ $t("checking_in") }}</span>
        </a> -->
      </div>

      <div class="stand-content">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide class="menu-box" v-for="link in data.links" :key="link.id">
            <a target="_blank" :href="link.url" class="wrapper">
              <div class="icon-container">
                <i :style="svgfilter($store.state.event.color) + ';background-image: url(/static/menuicons/module-link.svg); fill:'"></i>
              </div>

              <div class="title" :style="'color: ' + $store.state.event.color">
                {{ link.title }}
              </div>
            </a>
          </swiper-slide>
        </swiper>
        <div class="stand-row" v-if="data.managers.length > 0">
          <h4 class="stand-row-title" style="margin-top:0">
            {{$t('stand_authorities')}}
          </h4>

          <div class="participants-list">
            <div class="participant-item" v-for="item in data.managers" :key="item.id">
              <div
                class="participant-avatar"
                @click="$root.$emit('getProfile', item.participant.userID)"
                :style="{
                  'border-color': item.participant.tag.color,
                  'background-image': 'url(' + item.participant.image + ')'
                }"
              ></div>
              <div class="participant-title" @click="$root.$emit('getProfile', item.participant.userID)">
                <p>
                  {{ item.participant.firstName + " " + item.participant.lastName }}
                  <strong v-if="item.participant.title != null">@{{ item.participant.title }}</strong>
                </p>
                <p>{{ item.participant.tag.title }}</p>
              </div>
              <!-- <div class="participant-appointment cursor-pointer">
                <div class="fas fa-phone fa-lg" :style="{'color': currentEvent.color}"></div>
              </div> -->
              <div class="participant-operations" v-if="item.participant != null && item.participant.userID != null">
                <el-button type="primary" round size="mini" @click="createAppointment(item.participant)" v-if="currentEvent && currentEvent.settings && currentEvent.settings.isB2BNetworkingEnabled">
                  <i class="fas fa-calendar-check"></i>
                  {{ $t("appointment.title") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="stand-row" v-if="data.gallery != null && data.gallery.length != 0">
          <h4 class="stand-row-title" style="margin-top:0px;">{{ $t("gallery") }}</h4>

          <div class="gallery-grid">
            <div class="gallery-item" @click="index = imageIndex" v-for="(item, imageIndex) in data.gallery" :key="item.id" :style="item.type == 1 ? 'background-color: #292F3B;' : ''">
              <img class="gallery-background" :src="item.type == 1 ? parseYoutubeImage(item.url) : $imageus + item.url + '?width=300&height=300&mode=cover'" :style="item.type == 1 ? 'border-radius:0px;' : ''" />
              <i class="fa fa-play" v-if="item.type == 1" />
            </div>
          </div>
        </div>
        <div class="stand-row">
          <h4 class="stand-row-title" style="margin-top:0">
            {{ $t("stand_about") }}
          </h4>
          <div v-html="data.detail"></div>
          <div class="stand-location" v-if="data.location != null">
            <div class="location-title">
              {{ data.location.venue }}
            </div>
            <div class="location-address">
              {{ data.location.address }}
            </div>
            <div class="map-area" v-if="data.location.latitude != null && data.location.longtitude != null">
              <iframe :src="'https://maps.google.com/maps?key=AIzaSyBFvywbzSPYDlFHu58im4riFWW9xv-R5FY&q=' + data.location.latitude + ',' + data.location.longtitude + '&output=embed'" width="100%" height="auto" style="border: 0;aspect-ratio:16/9" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div class="mobile-contact">
              <div class="mobile-contact-left">
                <a class="contact-area" v-if="data.organizator.phoneNumberIsActive && data.organizator.phoneNumber != null" :href="'tel:' + data.organizator.phoneNumber">
                  <i class="fas fa-phone-alt"></i>
                </a>
                <a class="cellPhone" v-if="data.organizator.mobilePhoneIsActive && data.organizator.mobilePhone != null" :href="'tel:' + data.organizator.mobilePhone">
                  <i class="fas fa-mobile"></i>
                </a>
                <a class="mail" v-if="data.organizator.emailIsActive && data.organizator.email != null" :href="'tel:' + currentEvent.organizator.email">
                  <i class="fas fa-envelope"></i>
                </a>
              </div>
              <div class="mobile-contact-right" v-if="data.location.longtitude != null && data.location.longtitude != ''">
                <el-button size="mini" type="primary" @click="googleMaps(data.location.latitude, data.location.longtitude)" round>{{ $t("directions") }}</el-button>
              </div>
            </div>
            <div class="social-bar-home">
              <div class="social-icon twitter" v-if="data.socialMedia.twitterIsACtive">
                <a :href="data.socialMedia.twitter" target="_blank">
                  <i class="fab fa-twitter"></i>
                </a>
              </div>

              <div class="social-icon linkedIn" v-if="data.socialMedia.linkedInIsActive">
                <a :href="data.socialMedia.linkedIn" target="_blank">
                  <i class="fab fa-linkedin"></i>
                </a>
              </div>

              <div class="social-icon facebook" v-if="data.socialMedia.facebookIsActive">
                <a :href="data.socialMedia.facebook" target="_blank">
                  <i class="fab fa-facebook"></i>
                </a>
              </div>

              <div class="social-icon instagram" v-if="data.socialMedia.instagramIsActive">
                <a :href="data.socialMedia.instagram" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </div>

              <div class="social-icon youtube" v-if="data.socialMedia.youtubeIsActive">
                <a :href="data.socialMedia.youtube" target="_blank">
                  <i class="fab fa-youtube"></i>
                </a>
              </div>

              <div class="social-icon website" v-if="data.socialMedia.websiteIsActive">
                <a :href="data.socialMedia.website" target="_blank">
                  <i class="fas fa-globe"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- 
        <div
          class="stand-row"
          v-if="data.surveys != null && data.surveys.length != 0"
        >
          <h4 class="stand-row-title">{{ $t("stand_surveys") }}</h4>

          <SurveyList :ids="data.surveys" />
        </div> -->
      </div>
    </div>
    <gallery :images="getGallery" :index="index" @close="index = null"></gallery>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
import ifilter from "../../assets/imagefilter.js";
import SurveyList from "@/components/event/SurveyList";
import axios from "axios";
import VueGallery from "vue-gallery";
//import { Viewer } from "photo-sphere-viewer";

export default {
  name: "StandDetail",

  components: {
    ifilter,
    gallery: VueGallery,
    SurveyList
  },

  data() {
    return {
      moment,
      data: null,
      index: null,
      viewer: null,
      checkinTimeout: null,
      loading: false,
      swiperOption: {
        slidesPerView: "auto"
      }
    };
  },

  async created() {
    await this.$store.dispatch("getGroups", {
      id: this.currentEvent.id,
      route: false
    });

    var res = await axios.post("stand/get", {
      id: this.$route.params.stand_id
    });
    this.data = res.data.data.item;

    if (this.data.checkInTypes.some(x => x == 2)) {
      this.checkinTimeout = setTimeout(() => {
        this.standCheckin();
      }, 3000);
    }
  },

  beforeDestroy() {
    if (this.checkinTimeout) {
      clearTimeout(this.checkinTimeout);
    }
  },

  methods: {
    googleMaps(lat, long) {
      var latitude = parseFloat(lat);
      var longtitude = parseFloat(long);
      window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longtitude}`, "_blank");
    },
    createAppointment(participant) {
      this.$root.$emit("makeAppointmentDialog", JSON.parse(JSON.stringify(participant)), this.currentEvent.id, this.data.title, 1);
    },
    svgfilter(hex) {
      return ifilter.hexfilter(hex).filter;
    },
    standCheckin() {
      this.loading = "autoCheckIn";
      if (this.data.isCheckedIn == false) {
        axios.post("stand/checkin", {
          standID: this.$route.params.stand_id,
          currentStandID: this.$route.params.stand_id,
          questions: []
        });
        this.data.isCheckedIn = true;
        this.loading = false;
      }
    },
    go(survey) {
      if (survey.isCompleted) {
        return;
      }
      this.$router.push({
        name: "survey-detail",
        params: { survey: survey, survey_id: survey.survey.id }
      });
    },
    parseYoutubeImage(url) {
      return "http://i3.ytimg.com/vi/" + url.replace("https://youtu.be/", "") + "/maxresdefault.jpg";
    }
  },

  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentGroups() {
      return this.$store.getters.getGroups;
    },
    getGallery() {
      var data = [];

      if (this.data == null || this.data == undefined) {
        return [];
      }

      this.data.gallery.map(i => {
        if (i.type == 1) {
          data.push({
            poster: this.parseYoutubeImage(i.url),
            youtube: i.url.replace("https://youtu.be/", ""),
            type: "text/html"
          });
        } else {
          data.push(i.url);
        }
      });

      return data;
    }
  }
};
</script>

<style lang="less">
#stand-detail {
  background-color: #fbfbfb;
  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  padding: 0px 20px;

  .container {
    display: unset;
    max-width: 1120px;
    margin: 0 auto;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 5px;
    margin-bottom: 40px;
    margin-top: 20px;
    border-radius: 8px;
    width: 100%;
  }

  .header {
    width: 100%;
    max-width: 1120px;
    height: auto;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .stand-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 28px 20px;
    margin-bottom: 20px !important;
    margin-top: -22px !important;
    z-index: 2;

    border-bottom: 1px solid #f1f3f6;

    .logo {
      border: 3px solid #fff;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 6px;
      width: 120px;
      height: 120px;
      border-radius: 8px;
      background: rgb(236, 236, 236);
      cursor: default;
      margin-right: 1.25rem !important;

      img {
        border-radius: 6px;
      }
    }

    .stand-title {
      margin-top: 16px;
      color: #292f3b !important;
      display: flex;
      flex: 1;
      flex-direction: column;
      h1 {
        margin: 0;
        font-weight: 700;
        font-size: 22px;
        color: #292f3b !important;
        letter-spacing: -0.015em;
        line-height: 1.5385;
      }

      span {
        color: #505763;
        font-size: 14px;
        font-weight: 500;
        align-items: center;
        justify-content: flex-start;
        flex-direction: row;
        display: flex !important;
        margin-top: 3px;

        i {
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: contain;
          width: 16px;
          height: 16px;
          margin: 0;
          padding: 0;
          cursor: pointer;
        }
      }
    }

    .checkin-button {
      margin-top: 1.25rem;
      border: 0.5px solid #d6d9d9;
      border-radius: 8px;
      padding: 14px 28px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      cursor: pointer;
      text-decoration: unset;

      span {
        font-size: 18px;
        color: #fff;
        font-weight: 500;
        i {
          font-size: 18px;
          margin-right: 7px;
        }
      }
    }
  }

  .stand-content {
    padding: 0px 20px 20px 20px;
    .stand-container {
      display: flex;
      gap: 1rem;
      .stand-left {
        min-width: 30%;
      }
    }
    .menu-box {
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border: unset !important;

      cursor: pointer;

      &:first-child {
        margin-left: 0px;
      }

      .wrapper {
        justify-content: start;
        display: flex;
        align-items: center;
        flex-direction: column;
        flex: 1;
        display: flex;
        width: 100%;
        border-radius: 0px;
        text-decoration: none;

        .icon-container {
          border-radius: 8px;
          width: 50px;
          height: 50px;
          border: 0.5px solid #d6d9d9;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          text-decoration: none;

          i {
            font-size: 30px;
            margin-bottom: 0px;
            display: block;
            background-position: 50%;
            background-repeat: no-repeat;
            background-size: contain;
            height: 22px;
            width: 22px;
            cursor: pointer;
          }
        }

        .title {
          color: #505763 !important;
          margin-top: 3px;
          font-size: 13px;
          max-height: 40px;
          overflow: hidden;
        }

        &.is-active {
          border-radius: 8px;
          i {
            color: #fff !important;
          }
          .title {
            color: #505763 !important;
            font-weight: 500;
            font-size: 13px;
          }
        }
      }

      .title {
        padding: 0px 10px;
        display: block;
        width: 100%;
        box-sizing: border-box;
        text-align: center;
      }
    }
  }

  .stand-row {
    border-top: 1px solid #ccc;
    padding-top: 1rem;
    margin-top: 1rem;
    &:nth-child(2) {
      margin-top: unset !important;
    }
    .participants-list {
      width: 100%;

      .participant-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        border: 0.5px solid #d6d9d9;
        border-radius: 8px;
        padding: 6px 12px;
        margin-bottom: 10px;

        &:hover {
          background-color: #fbfbfb;
          transition: all 0.3s ease 0s;
        }

        .participant-avatar {
          width: 45px;
          height: 45px;
          aspect-ratio: 1;
          background-size: cover;
          border-radius: 50%;
          border: 4px solid #f1f1f1;
          cursor: pointer;
        }
        .participant-appointment {
          justify-self: flex-end;
        }

        .participant-title {
          margin-left: 12px;
          width: ~"calc(100% - 110px)";
          cursor: pointer;

          p {
            margin: 0px;
            padding: 0px;
            font-weight: 400;
            color: #292f3b;
            font-size: 16px;

            &:last-child {
              color: #8c929c;
              font-size: 13px;
            }

            strong {
              font-weight: 600;
            }
          }
        }

        .participant-operations {
          display: block;

          .invite-button {
            box-shadow: unset;

            i {
              color: #8c929c;
            }
          }
        }
      }
    }
    .stand-location {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .mobile-contact {
        padding-bottom: 1rem;
        border-bottom: 1px solid #c8cdd3;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        & > .mobile-contact-left {
          display: flex;
          gap: 10px;
          flex-direction: row;
          & > a {
            text-decoration: none;
            user-select: none;
            width: 28px;
            background: #268ea6;
            border-radius: 28px;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            height: 28px;
          }
        }
        & > .mobile-contact-right {
          width: auto;
          & > .el-button {
            font-weight: bold !important;
          }
        }
      }
      .location-title {
        font-size: 21px;
        font-weight: 700;
        line-height: 20px;
      }
      .location-address {
        font-weight: 500;
      }
    }

    .stand-row-title {
      font-size: 21px;
      font-weight: 700;
      line-height: 20px;
    }

    &:last-child {
      border-bottom: unset;
    }

    .gallery-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      grid-gap: 10px;
      margin: 0px;

      .gallery-item {
        cursor: pointer;
        width: 100%;
        height: auto;
        background-size: cover;
        background-position: 50%;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .gallery-background {
          border-radius: 8px;
          width: 100%;
          height: auto;
        }

        i {
          color: white;
          font-size: 25px;
          text-shadow: rgba(0, 0, 0, 0.56) 0px 0px 6px;
          position: absolute;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  #stand-detail {
    padding: 0px;

    .container {
      margin-top: 0px;
      border-radius: 0px;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      margin-bottom: 0px;
      padding-bottom: 40px;
    }

    .header {
      height: auto !important;
      border-radius: 0px;
    }

    .stand-header {
      padding: 0 6px 15px;
      margin-bottom: 20px !important;
      margin-top: -10px !important;

      .logo {
        width: 70px;
        height: 70px;
        margin-right: 0.8rem !important;
      }

      .stand-title {
        margin-top: 20px;

        h1 {
          font-size: 16px;
          color: #292f3b !important;
          letter-spacing: -0.015em;
          line-height: 1;
        }

        span {
          font-size: 12px;
          margin-top: 0px;

          i {
            width: 12px;
            height: 12px;
          }
        }
      }

      .checkin-button {
        display: none;
      }
    }

    .stand-content {
      padding: 0px 6px 20px 6px;

      .swiper-container {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        width: 100%;
        margin-bottom: 20px;

        .swiper-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 1;
          display: flex;
          transition-property: transform;
          box-sizing: content-box;
        }
      }

      .stand-row {
        .gallery-grid {
          grid-template-columns: 1fr 1fr 1fr;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/StandDetail.vue